import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import ScheduleInterviewModal from '../../ScheduleInterviewModal';
var getSelectedCoworkers = function getSelectedCoworkers(interview, possibleInterviewers) {
  var selectedCoworkers = [];
  interview.attendees.invitees.forEach(function (attendee) {
    var coworker = possibleInterviewers.team_members.find(function (teamMember) {
      return teamMember.email === attendee || teamMember.name === attendee;
    });
    if (coworker) {
      selectedCoworkers.push({
        value: coworker.email,
        label: coworker.name || coworker.email
      });
    }
  });
  return selectedCoworkers;
};
var EditInterviewModal = /*#__PURE__*/function (_React$Component) {
  function EditInterviewModal() {
    _classCallCheck(this, EditInterviewModal);
    return _callSuper(this, EditInterviewModal, arguments);
  }
  _inherits(EditInterviewModal, _React$Component);
  return _createClass(EditInterviewModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        editInterviewPath = _this$props.editInterviewPath,
        csrfToken = _this$props.csrfToken,
        possibleInterviewers = _this$props.possibleInterviewers,
        invitableRoles = _this$props.invitableRoles,
        interview = _this$props.interview,
        editModalRef = _this$props.editModalRef,
        location = _this$props.location,
        disableAvailabilitySelection = _this$props.disableAvailabilitySelection,
        interviewReschedule = _this$props.interviewReschedule,
        resheduleModalRef = _this$props.resheduleModalRef,
        interviewType = _this$props.interviewType,
        availableInterviewSlotUrl = _this$props.availableInterviewSlotUrl;
      var selectedCoworkers = getSelectedCoworkers(interview, possibleInterviewers);
      var consultantName = interview.attendees.consultant;
      var modalTriggerCopy;
      if (interviewReschedule || interviewType === 'reschedule') {
        modalTriggerCopy = 'Reschedule';
      } else if (disableAvailabilitySelection) {
        modalTriggerCopy = 'Edit Attendees';
      } else {
        modalTriggerCopy = 'Edit Times';
      }
      return /*#__PURE__*/React.createElement(ScheduleInterviewModal, {
        createInterviewUrl: editInterviewPath,
        csrfToken: csrfToken,
        consultantName: consultantName,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        modalTriggerType: "link",
        modalTriggerCopy: modalTriggerCopy,
        modalTriggerClassName: "edit-interview-cta",
        availabilities: interview.availabilities,
        timezone: interview.timezone,
        selectedCoworkers: selectedCoworkers,
        excludedInterviewInvitees: [interview.attendees.requester],
        isEditing: true,
        ref: interviewReschedule ? resheduleModalRef : editModalRef,
        location: location,
        disableAvailabilitySelection: disableAvailabilitySelection,
        interviewReschedule: interviewReschedule,
        interviewType: interviewType,
        rescheduleInterviewPath: interview.reschedule_interview_path,
        availableInterviewSlotUrl: availableInterviewSlotUrl
      });
    }
  }]);
}(React.Component);
EditInterviewModal.propTypes = {
  editInterviewPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  interview: PropTypes.shape({
    availabilities: PropTypes.arrayOf(PropTypes.shape({})),
    timezone: PropTypes.string,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      requester: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string)
    })
  }).isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  location: PropTypes.string,
  disableAvailabilitySelection: PropTypes.bool,
  interviewReschedule: PropTypes.bool,
  interviewType: PropTypes.string.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
EditInterviewModal.defaultProps = {
  editModalRef: function editModalRef() {
    return null;
  },
  resheduleModalRef: function resheduleModalRef() {
    return null;
  },
  location: 'Location Not Specified',
  disableAvailabilitySelection: false,
  interviewReschedule: false
};
export default EditInterviewModal;